export default __webpack_public_path__ + "static/media/fmc.cf601cd9.jpg";